import {
    TwoFactorAuthenticationDailyActivationStatistics,
    TwoFactorAuthenticationGenerateConfiguration,
    TwoFactorAuthenticationStatistics,
} from '../../types/twoFactorAuthentication';
import { OF } from '../../util';
import { JBaseApi } from '../base';

export class JTwoFactorAuthenticationApi extends JBaseApi {
    public hasSecret(signal?: AbortSignal) {
        return this.network.get<boolean>('twoFactorAuthentication', 'hasSecret', undefined, signal);
    }

    public twoFactorAuthenticationGenerateConfiguration(signal?: AbortSignal) {
        return this.network.postCSRF<TwoFactorAuthenticationGenerateConfiguration>(
            {
                o: 'twoFactorAuthentication',
                f: 'generateConfiguration',
            } as OF,
            signal,
        );
    }

    public verifyKey(key: string, signal?: AbortSignal) {
        return this.network.postCSRF<boolean>(
            {
                o: 'twoFactorAuthentication',
                f: 'verifyKey',
                key,
            } as OF,
            signal,
        );
    }

    public resetSecret(signal?: AbortSignal) {
        return this.network.postCSRF<boolean>(
            {
                o: 'twoFactorAuthentication',
                f: 'resetSecret',
            } as OF,
            signal,
        );
    }

    public isKeyValid(payload: { mail: string; key: string }, signal?: AbortSignal) {
        return this.network.postCSRF<boolean>(
            {
                o: 'twoFactorAuthentication',
                f: 'isKeyValid',
                ...payload,
            } as OF,
            signal,
        );
    }

    public activationStatistics(signal?: AbortSignal) {
        return this.network.get<TwoFactorAuthenticationStatistics>(
            'twoFactorAuthentication',
            'activationStatistics',
            undefined,
            signal,
        );
    }

    public twoFactorAuthenticationGetUserMail(signal?: AbortSignal) {
        return this.network.get<string>('twoFactorAuthentication', 'getUserMail', undefined, signal);
    }

    public twoFactorAuthenticationDailyActivationStatistics(dateStart: string, dateEnd: string, signal?: AbortSignal) {
        return this.network.get<TwoFactorAuthenticationDailyActivationStatistics>(
            'twoFactorAuthentication',
            'dailyActivationStatistics',
            { dateStart, dateEnd },
            signal,
        );
    }
}
